function initLazyLoad() {
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const src = img.getAttribute('data-lazyload-src');
        if (src) {
          img.src = src;
          //img.removeAttribute('data-lazyload-src'); // optional cleanup
          img.classList.add('lazyloaded');
          obs.unobserve(img);
        }
      }
    });
  }, {
    threshold: 0.1
  });

  // Observe initial images
  const lazyImages = document.querySelectorAll('img[data-lazyload-src]');
  lazyImages.forEach(img => observer.observe(img));

  // Watch for dynamically added lazy images
  const domObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) { // ELEMENT_NODE
          // Direct match
          if (node.matches?.('img[data-lazyload-src]')) {
            observer.observe(node);
          }
          // Nested matches
          const nested = node.querySelectorAll?.('img[data-lazyload-src]');
          nested?.forEach(img => observer.observe(img));
        }
      });
    });
  });

  domObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

initLazyLoad();